import { ConcreteFormStepProps } from './interfaces'
import { useTranslation } from 'react-i18next'
import { Controller } from 'react-hook-form'
import { NextStep } from '../components/NextStep'
import { Box, Stack, TextField, Typography } from '@mui/material'
import React from 'react'
import { useStepForm } from './hooks'
import * as yup from 'yup'
import Grid from '@mui/material/Unstable_Grid2'
import { CountrySelect } from '../components/CountrySelect'

export const CompanyAddress = ({ values, onSubmit, lead }: ConcreteFormStepProps) => {
    const { t } = useTranslation()
    const schema = yup.object({
        streetAddress: yup.string().required(),
        postalCode: yup.string().required(),
        locality: yup.string().required(),
        country: yup.string().required()
    })
    const {
        control,
        handleSubmit,
        continueDisabled,
        augmentedFieldProps,
    } = useStepForm('CompanyAddress', schema, values, false)

    return <>
        <Typography mb={4} variant="h5" component="h1">{t('CompanyAddress.heading')}</Typography>

        <Box mb={3}>
            <TextField
                label={t('CompanyAddress.companyName.label')}
                value={lead.companyName}
                disabled={true}
                fullWidth={true}
            />
        </Box>

        <form onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={3}>
                <Controller
                    name="streetAddress"
                    control={control}
                    defaultValue=""
                    render={({ field }) => <TextField
                        {...augmentedFieldProps(field)}
                        fullWidth={true}
                    />}
                />

                <Box>
                    <Grid container columnSpacing={2}>
                        <Grid xs={4}>
                            <Controller
                                name="postalCode"
                                control={control}
                                defaultValue=""
                                render={({ field }) => <TextField
                                    {...augmentedFieldProps(field)}
                                />}
                            />
                        </Grid>
                        <Grid xs={8}>
                            <Controller
                                name="locality"
                                control={control}
                                defaultValue=""
                                render={({ field }) => <TextField
                                    {...augmentedFieldProps(field)}
                                    fullWidth={true}
                                />}
                            />
                        </Grid>
                    </Grid>
                </Box>
                <Controller
                    name="country"
                    control={control}
                    defaultValue={null}
                    render={({ field }) => <CountrySelect
                        {...augmentedFieldProps(field)}
                    />}
                />
            </Stack>

            <NextStep/>
        </form>
    </>
}
